import { render, staticRenderFns } from "./MyNull.vue?vue&type=template&id=11320b77&"
import script from "./MyNull.vue?vue&type=script&lang=ts&"
export * from "./MyNull.vue?vue&type=script&lang=ts&"
import style0 from "./MyNull.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports